import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <p className="text-6xl md:text-8xl font-heading font-bold text-primary-200 mb-4">404</p>
        <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-800 mb-2">
          页面未找到
        </h1>
        <p className="text-sm text-foreground-500 mb-6">
          您访问的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}